<div *ngIf="!showInput" class="d-flex align-items-center" style="cursor: pointer" (click)="!disabled ? showInput = !showInput : null">
  <div #ref>
    <ng-content></ng-content>
  </div>
  <div *ngIf="!ref.innerHTML.trim()">{{ input }}</div>
  <div>
    <fa-icon class="ml-2" *ngIf="!disabled" icon="pencil"></fa-icon>
  </div>
</div>
<div *ngIf="showInput" (keyup.enter)="close()" (keyup.esc)="close()">
  <input
    required
    class="form-control w-75 d-inline mr-2 input-field"
    autofocus="true"
    type="text"
    [placeholder]="input"
    [(ngModel)]="input"
    (ngModelChange)="inputChange.emit(input)"
    [name]="name"
  />
  <button class="btn btn-primary btn-sm btn-icon" (click)="close()">
    <fa-icon [icon]="['fal', 'check']"></fa-icon>
  </button>
</div>
